import { render, staticRenderFns } from "./VueSelectMultiple.vue?vue&type=template&id=36dce4f5&"
import script from "./VueSelectMultiple.vue?vue&type=script&lang=js&"
export * from "./VueSelectMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports